import { z } from "zod/v4";

export const PAYMENTS_GLOBAL_SEARCH_MIN_LENGTH = 3;
export const PAYMENTS_GLOBAL_SEARCH_MIN_LENGTH_MESSAGE = `Search must be at least ${PAYMENTS_GLOBAL_SEARCH_MIN_LENGTH} characters`;

export function normalizePaymentsGlobalSearch(value: string | undefined) {
  const trimmed = value?.trim();
  return trimmed && trimmed.length >= PAYMENTS_GLOBAL_SEARCH_MIN_LENGTH
    ? trimmed
    : undefined;
}

export const paymentsGlobalSearchSchema = z.preprocess((value) => {
  if (typeof value !== "string") {
    return value;
  }

  const trimmed = value.trim();
  return trimmed === "" ? undefined : trimmed;
}, z.string().min(PAYMENTS_GLOBAL_SEARCH_MIN_LENGTH, PAYMENTS_GLOBAL_SEARCH_MIN_LENGTH_MESSAGE).optional());

export const paymentsGlobalSearchParamSchema = z.preprocess(
  (value) =>
    typeof value === "string"
      ? normalizePaymentsGlobalSearch(value)
      : undefined,
  z.string().optional(),
);
